/* -------------------------------------------------------------------------
 * Sayuri signature · scent-trail  (Watashi no Koibito)
 * -------------------------------------------------------------------------
 * Port of `ScentTrail` in the design file (line ~1301). Soft drifting
 * wisps — large blurred accent-soft ellipses placed anywhere on the
 * viewport, pulsing between two positions/scales/opacities on three
 * phase-offset keyframes. Meant to feel like perfume trails hanging in
 * the air.
 *
 * Scent character: "A lover's neck, ink on rice paper, a heartbeat
 * through silk." Romantic + intimate + lingering.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('scent-trail', {
    mount: function (el, ctx) {
      var n = ctx.intensity === 'lush' ? 18 : 12;
      var accentSoft = ctx.accentSoft;
      var rand = ctx.seed('scent-trail'.charCodeAt(0) * 131 + 11 * 7919);

      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var left = rand() * 100;
        var top = rand() * 100;
        var w = 120 + rand() * 200;       // 120–320px wide
        var dur = 24 + rand() * 18;       // 24–42s (was 12–22s; intimate slow)
        var delay = -rand() * 36;
        var variant = i % 3;

        var p = document.createElement('div');
        p.className = 'sayuri-scent-wisp';
        p.style.position = 'absolute';
        p.style.left = left + 'vw';
        p.style.top = top + 'vh';
        p.style.width = w + 'px';
        p.style.height = (w * 0.6) + 'px';
        p.style.background =
          'radial-gradient(ellipse, ' + accentSoft + '55, transparent 65%)';
        p.style.filter = 'blur(30px)';
        p.style.animation = 'scent-drift-' + variant + ' ' + dur + 's ease-in-out ' + delay + 's infinite';

        frag.appendChild(p);
      }
      el.appendChild(frag);
    },
    css: [
      '@keyframes scent-drift-0 { 0%,100%{transform:translate(0,0) scale(1);opacity:0.5;} 50%{transform:translate(80px,-40px) scale(1.3);opacity:0.9;} }',
      '@keyframes scent-drift-1 { 0%,100%{transform:translate(0,0) scale(1);opacity:0.4;} 50%{transform:translate(-100px,30px) scale(1.4);opacity:0.85;} }',
      '@keyframes scent-drift-2 { 0%,100%{transform:translate(0,0) scale(1);opacity:0.5;} 50%{transform:translate(40px,60px) scale(1.2);opacity:0.8;} }'
    ].join('')
  });
})();
